import Vue from 'vue';
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import ABaseComponent from "Components/Base/ABaseComponent";
import { CreatePorterItemCommandArguments, DeletePorterItemCommandArguments, PorterKey } from "Api/CoreApi";
import { State } from "vuex-class";
import { PorterBuilderState } from "Store/types";
import porterBuilder from 'Store/porterbuilder/porterbuilder';

@Component({
    template: "#add-to-porter-confirm-sizes-modal"
})
export default class PorterBuilderModalComponent extends ABaseComponent {
    saved:boolean = false;
    comment = "";
    errored : boolean = false;
    @Prop({default:''})
    defaultSizeComment : string;
    
    get porterBuilder(){
        return porterBuilder.state;
    }
    
    created() {
        if(this.defaultSizeComment)
        {
            this.comment = this.defaultSizeComment;
        }

        this.setLoaded();
    }
    createPorterItem() {
        if(this.defaultSizeComment && !this.comment){
            this.errored = true;
            return;
        }

        this.setLoading();
        const args = new CreatePorterItemCommandArguments({
            porterKey: new PorterKey({
                id: this.porterBuilder.porterId
            }),
            comment: this.comment,
            itemNo: this.porterBuilder.modalItemNo
        });
        porterBuilder.dispatchCreatePorterItem(args).then(() => {
            this.setLoaded();
            this.saved = true;
            this.errored = false;
            porterBuilder.commitClearModalItemNumber();
            $.fancybox.close(true);
        }).catch(e => {
            this.setError(e);
            porterBuilder.dispatchClearModalItemNumber();
            this.errored = true;
        });
    }
}
Vue.component("porter-builder-modal",PorterBuilderModalComponent)